export const internationalBusinessConst = {
  path: "/single-programs/international-business",
  title: "ФАКУЛЬТЕТ ЭКОНОМИКИ И УПРАВЛЕНИЯ – МЕЖДУНАРОДНЫЙ БИЗНЕС",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Международный бизнес — мышление без границ</h2>
      <p>
        Эта программа готовит специалистов, способных управлять компаниями в условиях глобальной экономики. Вы изучите, как работают
        транснациональные корпорации, международные рынки, экспортно-импортные операции, финансы, логистика и маркетинг в международной
        среде.
      </p>
      <p>Образование строится на кейсах, аналитике, международной правовой базе и межкультурных коммуникациях.</p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Экономика и управление в международной торговле</li>
        <li>Международное бизнес-право и регулирование</li>
        <li>Внешнеэкономическая деятельность и экспортные стратегии</li>
        <li>Глобальные логистические цепочки</li>
        <li>Международный маркетинг и бренд-менеджмент</li>
        <li>Международные финансы и валютные рынки</li>
        <li>Переговоры и кросс-культурные коммуникации</li>
        <li>ESG и устойчивое развитие в глобальном бизнесе</li>
      </ul>
      <p>
        Программа включает работу над реальными бизнес-кейсами, симуляции, коллаборации с зарубежными университетами и стажировки в
        международных компаниях.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Специалист по внешнеэкономической деятельности (ВЭД)</li>
        <li>Международный менеджер</li>
        <li>Консультант по глобальному рынку</li>
        <li>Логист или менеджер по экспортно-импортным операциям</li>
        <li>Руководитель проектов международного уровня</li>
        <li>Аналитик транснациональных рынков и инвестиционных стратегий</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€55,000 до €100,000 в год</strong>
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом с глобальной признанностью</li>
        <li>Преподавание на русском и английском языках</li>
        <li>Гибкий график — очно или дистанционно</li>
        <li>Стажировки в международных компаниях и стартапах</li>
        <li>Программа адаптирована под современные вызовы и цифровую экономику</li>
        <li>Поддержка при поступлении и карьерном развитии от приёмной комиссии</li>
      </ul>
      <p>Международный бизнес — это умение действовать на глобальном уровне</p>
      <p>
        Наши выпускники работают в транснациональных корпорациях, внешнеэкономических департаментах, консалтинговых и инвестиционных
        компаниях Европы и мира.
      </p>
      <br />
      <p className="padding-left">«Глобальный рынок требует гибкости и знаний. Мы даём и то, и другое.»</p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия поможет выбрать программу, подготовить документы и пройти процесс поступления без ошибок.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очно или дистанционно
    Форма связи: Получить консультацию приемной комиссии
    Международный бизнес — мышление без границ
    Эта программа готовит специалистов, способных управлять компаниями в условиях глобальной экономики. Вы изучите, как работают транснациональные корпорации, международные рынки, экспортно-импортные операции, финансы, логистика и маркетинг в международной среде.
    Образование строится на кейсах, аналитике, международной правовой базе и межкультурных коммуникациях.
    Что вы будете изучать?
    • Экономика и управление в международной торговле
    • Международное бизнес-право и регулирование
    • Внешнеэкономическая деятельность и экспортные стратегии
    • Глобальные логистические цепочки
    • Международный маркетинг и бренд-менеджмент
    • Международные финансы и валютные рынки
    • Переговоры и кросс-культурные коммуникации
    • ESG и устойчивое развитие в глобальном бизнесе
    Программа включает работу над реальными бизнес-кейсами, симуляции, коллаборации с зарубежными университетами и стажировки в международных компаниях.
    Кем можно работать после окончания?
    • Специалист по внешнеэкономической деятельности (ВЭД)
    • Международный менеджер
    • Консультант по глобальному рынку
    • Логист или менеджер по экспортно-импортным операциям
    • Руководитель проектов международного уровня
    • Аналитик транснациональных рынков и инвестиционных стратегий
    Зарплата в Европе: от €55,000 до €100,000 в год
    Почему выбирают нас?
    • Европейский диплом с глобальной признанностью
    • Преподавание на русском и английском языках
    • Гибкий график — очно или дистанционно
    • Стажировки в международных компаниях и стартапах
    • Программа адаптирована под современные вызовы и цифровую экономику
    • Поддержка при поступлении и карьерном развитии от приёмной комиссии
    Международный бизнес — это умение действовать на глобальном уровне
    Наши выпускники работают в транснациональных корпорациях, внешнеэкономических департаментах, консалтинговых и инвестиционных компаниях Европы и мира.
    «Глобальный рынок требует гибкости и знаний. Мы даём и то, и другое.»

    Как поступить?
    Приёмная комиссия поможет выбрать программу, подготовить документы и пройти процесс поступления без ошибок.
  `,
};
